import React from 'react'

import useRegion from '../../hooks/useRegion'
import authorPage from '../../styles/components/authorPage/author_page'
import SocialLinks from '../SocialLinks'

const AuthorInfo = ({ author }) => {
  const regionName = useRegion()?.name
  const avatarProps = author?.avatar
    ? { className: 'image-hd', src: author.avatar }
    : { className: 'new12-logo', src: `/${regionName}.svg` }

  return (
    <div data-testid='author-info'>
      {author?.byline && <p className='byline'>{author.byline}</p>}
      {author?.position && <p className='position'>{author.position}</p>}
      <SocialLinks entity={author} />
      <div className='author-info'>
        <img {...avatarProps} alt={`Author ${author?.byline || ''} portrait`} />
        {author?.bio && <p>{author.bio}</p>}
      </div>
      <style jsx>{authorPage}</style>
    </div>
  )
}

export default AuthorInfo
